<div class="maincampaign" style="padding-top: 0; position: static;">
  <div class="card cardstep">
    <div class="ui-g ui-fluid">

      <div class="ui-g-12 campaign-card-pad">
        <p-steps [model]="items" [activeIndex]="step - 1"></p-steps>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/steps/campaign-steps.html